import { render } from "./BookHomePage.vue?vue&type=template&id=d8c66238"
import script from "./BookHomePage.vue?vue&type=script&lang=js"
export * from "./BookHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__